export default {
    header: 'My profile',
    saveChangesToSubmit: 'Save your profile for changes to take effect',
    saveChanges: 'Save changes',
    saveSuccessful: 'Your changes were successfully saved',

    personalDetails: {
        header: 'Personal details',
        firstName: 'First name',
        lastName: 'Last name',
        nationality: 'Nationality',
        gender: 'Gender',
        uploadProfileImage: 'Upload photo',
        genderOptions: {
            male: 'Male',
            female: 'Female',
            other: 'Other',
            none: 'Prefer not to say',
            unknown: 'Unknown',
        },

        wrongFileTypeErrorHeader: 'Invalid file type',
        wrongFileTypeErrorDescription: 'You can only upload images',
    },

    contactDetails: {
        header: 'Contact details',
        contactEmail: 'Contact email',
        phoneNumberHeader: 'Mobile phone number',
        countryCode: 'Country code',
        phoneNumber: 'Phone number',

        invalidEmail: 'Typed email is not a valid email.',

        permanentEmail:
            'NOTE: This change is permanent. You can only set your email once.',
    },

    languages: {
        header: 'Languages',
        languageLabel: 'Language',
        levelLabel: 'Level',
        addLanguage: 'Add new language',
        proficiencies: {
            '22f882cc-3cb0-4cfd-a590-ef010f4d798b': 'Elementary proficiency',
            '82edcac6-693b-42ea-bf24-0a52774f395c':
                'Limited working proficiency',
            'a97f6798-7280-4ce7-8896-6d4a8fb58c63':
                'Professional working proficiency',
            '93b37709-3f2d-4853-ac77-b8c0dd07243e':
                'Full professional proficiency',
            '250d296e-d6db-46fb-8c44-07950db80ec4':
                'Native or bilingual proficiency',
        },
    },

    education: {
        header: 'Education',
        addEducation: 'Add education',
        notGraduated: 'Not graduated yet',
        graduatedIn: 'Graduated in {date}',

        dialog: {
            addNewEducation: 'Add new education',
            degreeTitle: 'Program',
            institution: 'Institution',
            degreeType: 'Degree',
            fieldOfStudy: 'Field of Study',
            studyStart: 'Start month',
            studyEnd: 'Graduation month',
            invalidDegreeTitle: 'You need to fill in a title of your program.',
            invalidSchool: 'You need to select a school.',
            invalidStartDate: 'Please select a start date.',
            invalidEndDate: 'Please select a graduation date.',
            invalidStudyPeriod:
                'You can not graduate before the starting date.',
            invalidDegreeField: 'Please select a valid field of study.',
            invalidDegreeLevel: 'Please select a valid level of your degree.',
            selectStartDate: 'Start date',
            selectEndDate: 'Graduation date',

            degrees: {
                '5b468395-7bf7-4f14-88d9-32096884d4ef': 'Bachelor',
                '09f419fa-1517-41ce-970c-df0d073fc440': 'Master',
                '2c917ed6-5bb7-4e23-95ab-60c55d8df135': 'MBA',
                '1fff1451-f07c-415c-954a-63b1e5f44fc8': 'DBA',
                '2fbd6155-d939-40cc-970d-283be0aef433': 'PHD',
            },

            diciplins: {
                '383c2086-24da-4fe2-977b-7e3d4da85f8e':
                    'Agriculture & Forestry',
                'c8fb1348-bdac-4ed3-af7a-a831376d04b7':
                    'Applied Sciences & Professions',
                '5c665d94-5124-4226-a4f6-da8cca47e3f6':
                    'Arts, Design & Architechture',
                '06b028e2-d7ed-4281-8668-1009d6da1c35': 'Business & Management',
                '747624bb-0174-4961-a3c0-dbe4f1cb750d': 'Computer Science & IT',
                'ede2bbdb-7a1d-466c-99e5-bcab52e07d69': 'Economics',
                '5c0432d4-9297-429a-85c4-3305d207764e': 'Education & Training',
                '8198b6ea-5b28-4be2-afbc-45df759c65cb':
                    'Engineering & Technology',
                '7e5c0527-d1ec-4125-945e-138ec473e8dd':
                    'Environmental Studies & Earth Sciences',
                '3babe28b-6285-4a03-b0b8-43f55be393cd':
                    'Hospitality, Leisure & Sports',
                '9eebcc51-385e-4122-88a1-6dd3efbaf896': 'Humanities',
                '390cf111-b55a-4bb7-a6b6-1cc2b21a248f': 'Journalism & Media',
                'a2744908-9521-4330-a07d-3680b058d0a6': 'Law',
                '947993e1-b723-4d85-8cd9-a4ae46cd623e': 'Marketing',
                'c98802c8-74a5-4a98-99ba-84eb76fd1a60':
                    'Master of Science in Innovation and Business',
                'bca263cc-3d17-4ad8-b70e-e2bfe04421fa':
                    'Master in Development Management',
                'a37667e2-5713-4157-82e9-78c10760d2de':
                    'Master of Science in Data Science',
                '72277bb7-9d5e-422a-a2b4-8a8fb8be7143': 'Medicine & Health',
                'bd84a8cd-ce66-4c61-86a8-7fcb6644cc5d': 'MS in Finance',
                '9e665ac9-9611-4508-af4b-22e91f167ea4':
                    'MS in International Business Studies',
                'baf5bb0a-d0ab-4c13-aacc-c6a8a90e2fcf':
                    'MS in Business Analytics',
                '7d832109-642a-4730-aada-26927eb683ee': 'MS in Management',
                'baf05a5a-faba-4f30-9254-9cd73bb63bbf':
                    'Natural Sciences & Mathematics',
                '828cc4ac-1f2b-4133-8e29-ba1347585ae6': 'Social Sciences',
                '44c1f8cf-8696-4638-bc03-9763c2de32af': 'Other',
            },
        },
    },

    workAuthorization: {
        header: 'Work Authorization',
        addWorkAuthorization: 'Add work authorization',
        implicitValue: 'Based on your nationality',
        dialog: {
            selectCountry: 'Select country',
            addEuWorkAuthorization: 'Add EU work authorization',
        },
    },

    communication: {
        header: 'Communication',
        sendMeUpdatesDescription:
            'Please send me career news, positions and company updates by email',
    },

    errors: {
        imageUpload: {
            title: 'Could not upload image.',
            message: 'Image is too large!',
        },
    },

    exitDialog: {
        title: 'Unsaved changes will be lost',
        message:
            'You are trying to exit the page without saving your changes. Do you want to save your profile before moving on?',
        stayAction: 'Stay at this page',
        saveAction: 'Save profile',
        continueAction: 'Continue without saving',
    },
};
